export default __webpack_public_path__ + "static/media/CNo.62-4.7b1aadd1.jpg";